<template>
	<div id="overlay" @click.self="$emit('close')">
		<div id="modalcont" class="item_detail_text">
			<div class="item_title">
				<div style="margin-left: 10px;" class="item_sisetuname">
					<span>{{ item2.sisetu_name }}</span>
				</div>
			</div>
			<!-- <p class="detail_title">【活動内容】</p> -->
			<div class="scroll-detail">
				<div class="flex reflex status_box">
					<!-- 分野のアイコン表示仮 -->
					<ul class="bunya_list">
						<li v-if="item.katudo_bunya_id === 1" class="korei_icon">
							<span class="bunya_text">高齢者関係</span>
						</li>
						<li v-if="item.katudo_bunya_id === 2" class="syogai_icon">
							<span class="bunya_text">障がい児・者関係</span>
						</li>
						<li v-if="item.katudo_bunya_id === 3" class="jido_icon">
							<span class="bunya_text">児童関係</span>
						</li>
						<li v-if="item.katudo_bunya_id === 4" class="hoken_icon">
							<span class="bunya_text">保健・医療関係</span>
						</li>
						<li v-if="item.katudo_bunya_id === 5" class="sonota_icon">
							<span class="bunya_text">その他</span>
						</li>
					</ul>
					<div>
						<span v-if="(item.gakusei === 1)" class="ukeire_tag_g">学生ポイント制度対象</span>
						<span v-else class="ukeire_tag_g _false">学生ポイント制度対象</span>
						<span v-if="(item.supporter_check === 1)" class="ukeire_tag">地域福祉サポーター対象</span>
						<span v-else class="ukeire_tag _false">地域福祉サポーター対象</span>
					</div>
				</div>
				<dl class="inner">
					<dt class="detail_title">内容</dt>
					<dd class="detail_content kaigyo">
						{{item.naiyou}}
					</dd>
					<!-- <dt class="detail_title" v-if="item.henkonaiyo">変更内容</dt> -->
					<dd class="detail_content kaigyo henko" v-if="item.henkonaiyo">
						{{item.henkonaiyo}}
					</dd>
					<dt class="detail_title">活動期間・時間</dt>
							<dd class="detail_content">
								{{ item.kikan_from }} ～ {{ item.kikan_to }}
								<div class="flex item_box">
									<ul class="flex youbi">
										<li v-if="item.week1_check === 1"><span class="week">月</span></li>
										<li v-if="item.week2_check === 1"><span class="week">火</span></li>
										<li v-if="item.week3_check === 1"><span class="week">水</span></li>
										<li v-if="item.week4_check === 1"><span class="week">木</span></li>
										<li v-if="item.week5_check === 1"><span class="week">金</span></li>
										<li v-if="item.week6_check === 1"><span class="week">土</span></li>
										<li v-if="item.week7_check === 1"><span class="week">日</span></li>
										<li v-if="item.week1_check !== 1 && item.week2_check !== 1 && item.week3_check !== 1 && item.week4_check !==1 && item.week5_check !== 1 && item.week6_check !== 1 && item.week7_check !== 1">曜日にかかわらず</li>
									</ul>
									<span class="time_height">{{ String(item.jikan_from).slice(0,5) }}～{{String(item.jikan_to).slice(0,5)}}</span>
								</div>
							</dd>
					<dt class="detail_title">活動場所</dt>
					<dd class="detail_content kaigyo">
						〒{{item.zipcode}}<br>{{ item.address }}
					<br><fa icon="phone" class="icon" />{{item2.tel}}
					<br v-if="item.kotukikan">{{item.kotukikan}}
					<br>
					<a v-if="item2.url" :href="item2.url" class="btn_link btn_true btn_hp_map" target="_blank"><fa icon="home" class="icon" />HP</a>
					<a v-else class="btn_link btn_false btn_hp_map" target="_blank" disabled><fa icon="home" class="icon" />HP</a>
					<a v-if="item2.map_url" :href="item2.map_url" class="btn_link btn_true btn_hp_map" target="_blank"><fa icon="map-marked-alt" class="icon" />MAP</a>
					<a v-else class="btn_link btn_false btn_hp_map" target="_blank" disabled><fa icon="map-marked-alt" class="icon" />MAP</a>
					</dd>
					<dt class="detail_title">募集人員</dt>
					<dd class="detail_content" v-if="(item.jinin_code === 1)">
						性別を問わない&emsp;{{item.jinin_total}}名
					</dd>
					<dd class="detail_content" v-else>
						性別毎&emsp;男性：{{item.jinin_men}}名 女性：{{item.jinin_women}}名
						</dd>
					<dt class="detail_title">募集中ボランティア</dt>
					<dd class="detail_content">
						<ul class="flex ukeire_box detail_content">
							<li><span class="ukeire ukeire_syogaku" v-if="item.uke_syogaku_check === 1">小</span></li>
							<li><span class="ukeire ukeire_cyugaku" v-if="item.uke_cyugaku_check === 1">中</span></li>
							<li><span class="ukeire ukeire_koko" v-if="item.uke_koko_check === 1">高</span></li>
							<li><span class="ukeire ukeire_tansen" v-if="item.uke_tansen_check === 1">短</span></li>
							<li><span class="ukeire ukeire_daigaku" v-if="item.uke_daigaku_check === 1">大</span></li>
							<li><span class="ukeire ukeire_syuhu" v-if="item.uke_syuhu_check === 1">主</span></li>
							<li><span class="ukeire ukeire_kaisya" v-if="item.uke_kaisya_check === 1">会</span></li>
							<li><span class="ukeire ukeire_korei" v-if="item.uke_korei_check === 1">齢</span></li>
							<li><span class="ukeire ukeire_syogai" v-if="item.uke_syogai_check === 1">障</span></li>
						</ul>
					</dd>
					<dt v-if="item.kei_tyusya_check !== 0 || item.kei_syokuji_check !== 0 || item.kei_syokuji_teikyo_check !== 0 || item.kei_koutsu_check !== 0" class="detail_title">経費</dt>
					<dd class="detail_content">
						<ul v-if="item.kei_tyusya_check !== 0 || item.kei_syokuji_check !== 0 || item.kei_syokuji_teikyo_check !== 0 || item.kei_koutsu_check !== 0" class="flex keihi_box">
							<li v-if="item.kei_tyusya_check === 1">駐車場有</li>
							<li v-if="item.kei_syokuji_teikyo_check === 1">食事提供有</li>
							<li v-if="item.kei_syokuji_check === 1">食事代&ensp;{{item.kei_syokuji}}円</li>
							<li v-if="item.kei_koutsu_check === 1">交通費</li>
							<li v-if="item.kei_futan_check === 1">全額負担</li>
							<li v-if="item.kei_futan_check === 2">一部負担&ensp;{{item.kei_futan}}円</li>
						</ul>
					</dd>
					<dt class="detail_title" v-if="item.pr">活動先からのメッセージ</dt>
					<dd class="detail_content kaigyo" v-if="item.pr">
						{{item.pr}}
					</dd>
					<dt class="detail_title" v-if="item.tyuijiko">注意事項</dt>
					<dd class="detail_content kaigyo" v-if="item.tyuijiko">
						{{item.tyuijiko}}
					</dd>
				</dl>
			</div>
			<div class="modal_bottom">
				<div class="flex justifycont-c center buttons">
					<button @click="$emit('close')" class="btn_cancel">戻る</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { inject } from 'vue';
// import aixos from 'axios';
// import { format } from 'date-fns'
// import ja from 'date-fns/locale/ja'
export default {
	setup() {
		return {
			// format,
			// ja,
		}
	},
    props: {
        item: Object,
        item2: Object,
		// sisetu_name: String
    },
	data(){
		// let Time_from = String(this.item.jikan_from).slice(0,6);
		// return{
		// 	Time_from,
		// }
	},
	async created() {
		// console.log(this.bosyu)
		// const id = this.bosyu.id
		// console.log(this.bosyu.id)
		// let res = await aixos.get('/api/bosyu_data/info?id=' + id)
		// console.log(res.data)
		// this.item = res.data
	},
	methods: {
	},
}
</script>

<style>
</style>
